<template>
  <section class="loading-to-backoffice-v2">
    <div class="loading-to-backoffice-v2__loader"/>
    <span>Carregando...</span>
  </section>
</template>

<script>
import { REQUEST_SERVICE } from '../../../../requestConfig';
import { SET_TOKEN } from '../../../../urlConfig';
import { UTIL_SERVICE } from '../../../../utils';


  export default {
    name: 'loading',
    data() {
      return {
        currentHref: null,
        refreshToken: null,
        urlToRedirect: null,
      }
    },
    methods: {
      setUrlToRedirect(url) {
        this.$router.push('/' + url);
      },
      setTokenToV2(auth) {
        let authOld = auth;

        REQUEST_SERVICE.post(SET_TOKEN, {token: authOld.userToken}).then((response) => {
          authOld.token = response.data;
          UTIL_SERVICE.saveStorage('authUser', authOld);

          if (this.urlToRedirect) {
              this.setUrlToRedirect(this.urlToRedirect);
          }
        })
      },
    },
    beforeMount() {
      this.currentHref = new URL(window.location.href);

      if (this.currentHref) {
        this.refreshToken = this.currentHref.searchParams.get('rtoken');
        this.urlToRedirect = this.currentHref.searchParams.get('backurl');
      }
    },
    mounted() {
      const authUser = UTIL_SERVICE.getStorage('authUser');

      if (this.refreshToken == '1') {
        this.setTokenToV2(authUser);
      }
      else {
      this.$router.push('/');
      }
    }
  }
</script>

<style lang="scss">

.loading-to-backoffice-v2 {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  justify-content: center;

  &__loader {
    width: 50px;
    aspect-ratio: 1;
    border-radius: 50%;
    border: 8px solid #1b59f8;
    animation:
            l20-1 1s infinite linear alternate,
            l20-2 2s infinite linear;
  }
  @keyframes l20-1{
    0%    {clip-path: polygon(50% 50%,0       0,  50%   0%,  50%    0%, 50%    0%, 50%    0%, 50%    0% )}
    12.5% {clip-path: polygon(50% 50%,0       0,  50%   0%,  100%   0%, 100%   0%, 100%   0%, 100%   0% )}
    25%   {clip-path: polygon(50% 50%,0       0,  50%   0%,  100%   0%, 100% 100%, 100% 100%, 100% 100% )}
    50%   {clip-path: polygon(50% 50%,0       0,  50%   0%,  100%   0%, 100% 100%, 50%  100%, 0%   100% )}
    62.5% {clip-path: polygon(50% 50%,100%    0, 100%   0%,  100%   0%, 100% 100%, 50%  100%, 0%   100% )}
    75%   {clip-path: polygon(50% 50%,100% 100%, 100% 100%,  100% 100%, 100% 100%, 50%  100%, 0%   100% )}
    100%  {clip-path: polygon(50% 50%,50%  100%,  50% 100%,   50% 100%,  50% 100%, 50%  100%, 0%   100% )}
  }
  @keyframes l20-2{
    0%    {transform:scaleY(1)  rotate(0deg)}
    49.99%{transform:scaleY(1)  rotate(135deg)}
    50%   {transform:scaleY(-1) rotate(0deg)}
    100%  {transform:scaleY(-1) rotate(-135deg)}
  }

  span {
    color: #1b59f8;
    font-size: 24px;
    font-weight: 600;
    font-family: Montserrat, sans-serif;
  }
}

</style>



// WEBPACK FOOTER //
// src/vue/views/restricted/loading/loading.vue